import { useState } from 'react';
import { useAppState } from '../context/OmniboxJsonConverterContext';
import { loadSettings, loadTechniqueSettings, saveSetting } from './converterHelperFunctions';
import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
// import CloseIcon from '@mui/icons-material/Close';



function SelectTemplate() {
  const { selectedSetting, globalColumns, detectedTechnique, setSelectedSetting, setSelectedColumns, handleOpenAddTemplate, handleOpenRenameTemplate } = useAppState();
  const [open, setOpen] = useState(false);

  const savedTemplates = loadTechniqueSettings(detectedTechnique)['templates'];
  const templateNames = (savedTemplates == null) ? (['']) : (Object.keys(savedTemplates));

  const defaultTechniques = ['CMC', 'PVD', 'SC', 'RIC'];

  const removeTemplate = (templateName) => {
    const saved = loadSettings();
    delete saved[detectedTechnique]['templates'][templateName];

    localStorage.setItem('omnibox_json_converter', JSON.stringify(saved));
  }

  return (
    <Stack direction='row' spacing={2} alignItems='center' sx={{ display: 'flex', flex: '1 1 auto' }}>
      <Typography variant='caption' fontSize='12px'>Selected:</Typography>
      <FormControl variant='standard' sx={{ width: 'auto', minWidth: '25%' }}>
        <Select
          value={savedTemplates[selectedSetting] ? selectedSetting : detectedTechnique}
          onChange={(event) => {
            // const savedTemplates = loadTechniqueSettings(detectedTechnique);
            if (!savedTemplates[event.target.value]) {
              setSelectedSetting(detectedTechnique);
              setSelectedColumns(savedTemplates[detectedTechnique]);
            }
            else {
              setSelectedSetting(event.target.value);
              setSelectedColumns(savedTemplates[event.target.value]);
            }
          }}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          renderValue={(value => <span>{value}</span>)}
          MenuProps={{
            PaperProps: {
              sx: { width: 'auto' }
            }
          }}
        >
          {templateNames.map((template) =>
            <MenuItem value={template} key={template} selected={selectedSetting === template} sx={{ width: 'auto', minWidth: 240, p: '6px', pr: '1px' }}>
              {/* {template} */}
              <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1} sx={{ width: '100%' }}>
                <Typography variant='body1' fontSize='16px' sx={{ minWidth: '60%' }}>{template}</Typography>
                {open && (
                  <Stack direction='row' alignItems='center'>
                    <IconButton title='Edit' size='small' disabled={detectedTechnique === template} onClick={handleOpenRenameTemplate} sx={{ display: detectedTechnique === template ? 'none' : 'flex' }}>
                      <EditIcon fontSize='small' />
                    </IconButton>
                    <IconButton title='Delete' size='small' disabled={detectedTechnique === template} onClick={() => removeTemplate(template)} sx={{ display: detectedTechnique === template ? 'none' : 'flex' }}>
                      <DeleteIcon fontSize='small' />
                    </IconButton>
                  </Stack>
                )}
              </Stack>
            </MenuItem>
          )}

        </Select>
      </FormControl>
      <Button variant='outlined' size='small' onClick={handleOpenAddTemplate}>
        Add
      </Button>
    </Stack>
  )
}

export default SelectTemplate;